/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, LinkField } from 'framework/ui/field';
import { useProcessInstanceUrl } from 'domain/gpo/cockpit/instance/processInstanceRoute';

const ProcessInstanceLinkField = (props: any) => {
  const { getValue } = useFieldHelper(props);
  const { getSingleEntityUrl } = useProcessInstanceUrl();

  const id = getValue();
  const { label = id } = props;
  const url = getSingleEntityUrl(id);
  const { isInternal = true } = props;

  return <LinkField value={url} linkText={label} isInternal={isInternal} />;
};

export default ProcessInstanceLinkField;
